module.exports = __webpack_public_path__ + "static/media/michael2.dabae42d.jpeg";